<template>
  <div class="mb-3">
    <div class="progresszone" ref="progresszone" v-show="inProgress">
      <i class="fas fa-upload progresszone-header"></i>
      <div class="progress-wrapper w-50 text-right">
        <small>pliki: {{fileUploaded}} / {{fileToUpload}}</small>
        <b-progress
          height="2rem"
          :value="progressValue"
          show-progress
          variant="success"
          striped
          :animated="animated"
          class="my-3"
        ></b-progress>
      </div>
      <p class="progresszone-text">
        <span>Trwa wgrywanie plików</span>Proszę nie zamykać okna
      </p>
    </div>
    <div class="dropzone" ref="dropzoneoverlay" v-show="overlayActive">
      <i class="fas fa-upload dropzone-header"></i>
      <p class="dropzone-text">
        <span>Upuść pliki tutaj aby je wgrać</span>Dopuszczalne rozszerzenia plików to .jpeg, .bmp, .png, .pdf, .doc, .docx, .odt, .xlsx, .xls, .ods.
      </p>
    </div>
    <button
      class="btn btn-success mr-2"
      @click="$refs.inputCamera.click()"
      v-if="$isMobile()"
    >Zrób zdjęcie</button>
    <button class="btn btn-success mr-2" @click="$refs.inputfile.click()">Kliknij by dodać pliki</button>
    <input
      type="file"
      name="image"
      @change="changeInput"
      ref="inputfile"
      class="d-none"
      multiple="true"
    />
    <input
      type="file"
      name="image"
      @change="changeInput"
      ref="inputCamera"
      class="d-none"
      accept="image/*"
      capture="camera"
    />
    <strong class="d-block">lub przeciągnij i upuść pliki w te okno.</strong>
  </div>
</template>


<script>
// import { mapGetters, mapActions } from "vuex";
import ApiService from "@/services/api.service";

export default {
  name: "FilesUpload",
  props: {
    construction_id: { type: Number },
    category: { type: Object },
    dropzoneid: { type: String }
  },
  data() {
    return {
      animated: false,
      handleDropZone: null,
      overlayActive: false,
      inProgress: false,
      dragAndDropCapable: false,
      files: [],
      fileUploaded: 1,
      fileToUpload: 0,
      sizeUploaded: 0.0001,
      sizeToUpload: 0,
      progressValue: 0
    };
  },
  computed: {},
  mounted() {
    this.handleDropZone = document.getElementById(this.dropzoneid);
    if (this.$_.isEmpty(this.handleDropZone) === true) return;
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop"
      ].forEach(
        function(evt) {
          this.handleDropZone.addEventListener(
            evt,
            function(e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      this.handleDropZone.addEventListener(
        "dragleave",
        function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.inProgress) return;
          this.overlayActive = false;
        }.bind(this)
      );
      this.handleDropZone.addEventListener(
        "dragover",
        function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.inProgress) return;
          if (this.overlayActive === false) {
            this.overlayActive = true;
          }
        }.bind(this)
      );
      /*
          Add an event listener for drop to the form
        */
      this.handleDropZone.addEventListener(
        "drop",
        function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.inProgress) return;
          this.inProgress = true;
          this.overlayActive = false;
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push(e.dataTransfer.files[i]);
          }
          this.submitFiles();
        }.bind(this)
      );
    }
  },
  methods: {
    determineDragAndDropCapable() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    changeInput(e) {
      if (e.target.files.length === 0) return;
      this.inProgress = true;
      this.overlayActive = false;
      for (let i = 0; i < e.target.files.length; i++) {
        this.files.push(e.target.files[i]);
      }
      this.submitFiles();
    },
    submitFiles() {
      this.animated = true;
      this.fileUploaded = 1;
      this.fileToUpload = this.files.length;
      this.sizeUploaded = 0.0001;
      this.sizeToUpload = 0;
      this.progressValue = 0;
      this.files.forEach(item => {
        this.sizeToUpload += item.size;
      });
      this.sendFile();
    },

    sendFile() {
      let file = this.files.pop();
      let that = this;
      if (!file) {
        this.fileUploaded = this.fileToUpload;
        this.sizeUploaded = this.sizeToUpload;
        this.progressValue = 100;
        this.animated = false;
        setTimeout(() => {
          this.inProgress = false;
          this.$emit("endupload");
        }, 1000);
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("category_id", this.category.id);
      ApiService.customRequest({
        data: formData,
        url: "/construction/" + this.construction_id + "/files",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        skipmessage: true,
        onUploadProgress: function(progressEvent) {
          this.progressValue = parseInt(
            Math.round(
              ((progressEvent.loaded + this.sizeUploaded) / this.sizeToUpload) *
                100
            )
          );
        }.bind(this)
      })
        .then(function(response) {
          that.sizeUploaded += file.size;
          that.fileUploaded++;
          that.sendFile();
          that.$store.commit("lastapimessage/push", {
            message: "Plik " + response.data.filename + " został dodany",
            type: "success"
          });
          that.$store.commit("construction/fileAppend", {
            file: response.data,
            category_id: that.category.id
          });
        })
        .catch(function(e) {
          //Show must go on
          if (e.response) {
            that.$store.commit("lastapimessage/push", {
              message: "Błąd: plik " + file.name + " nie został zapisany",
              type: "danger"
            });
          }
          that.sizeUploaded += file.size;
          that.sendFile();
        });
    }
  }
};
</script>
